import { FeatureFlag } from '@/types/featureFlags';
import { api } from '../utils/api';

export const getFeatureFlagsService = async (companyUuid?: string) => {
  if (!companyUuid) {
    return [];
  }

  const { data } = await api<FeatureFlag[]>({
    url: `feature-flags/active?company_id=${companyUuid}`,
    method: 'get',
  });

  return data;
};
